import moment from 'moment';
import TimeConversionUtils, { DEFAULT_DATE_FORMAT } from '../lib/timeConversionUtils';
import generateId from '../lib/generateId';

export const NEW_DIARY_ID_PREFIX = 'new';

export default class DiaryService {
  constructor(dao) {
    this.dao = dao;
  }

  /**
   * Returns an array of diary objects
   * @param memberId: string
   * @param cognitoId: string
   * @param startDate: string (YYYY-MM-DD)
   * @param endDate: string (YYYY-MM-DD)
   */
  getDiariesByMemberIdAndDateRange(
    memberId,
    cognitoId,
    startDate = null,
    endDate = null,
  ) {
    return this.dao.getDailyDiaries(memberId, cognitoId, startDate, endDate);
  }

  /**
   * Gets the first not removed diary comment object or null if one does not exist
   * @param diary: object
   */
  // eslint-disable-next-line
  getFirstDiaryComment(diary) {
    let firstComment = null;
    if (diary && diary.comments !== null && diary.comments.length > 0) {
      firstComment = diary.comments[0];
    }
    return firstComment;
  }

  /**
   * Convert the api date to the format we'll use
   * @param date
   * @returns {*}
   */
  // eslint-disable-next-line
  formatApiDate(date) {
    // YYYY-MM-DD => YYYYMMDD
    return date.replace(/-/g, '');
  }

  /**
   * Sorts the array of comments by their created_on timestamps
   * @param comments (array)
   */
  // eslint-disable-next-line
  sortCommentsByDateTimeAsc(comments) {
    if (comments) {
      return comments.sort(
        (a, b) => TimeConversionUtils.compareMomentDateAsc(
          moment(a.created_on),
          moment(b.created_on),
        ),
      );
    }
    return null;
  }

  /**
   * Creates a new diary object
   * @param momentDate
   * @param member_id
   * @returns {{member_id: *, comments: [], diary_date: *, created_on: *,
   * daily_diary_id: *, removed_on: null}}
   */
  // eslint-disable-next-line
  getNewDiary(momentDate, member_id) {
    return {
      diary_date: momentDate.format(DEFAULT_DATE_FORMAT),
      daily_diary_id: `${NEW_DIARY_ID_PREFIX}_${generateId()}`,
      created_on: moment().toISOString(),
      member_id,
      removed_on: null,
      comments: [],
    };
  }
}
